<footer class="rs-table-banner rs-table-banner-bottom">
  <div class="rs-flex-row rs-justify-between-medium">
    <div class="rs-flex-columns small-12 medium-6 rs-order-m2">
      <div
        class="rs-pagination rs-table-banner-pagination rs-justify-between-small-only rs-justify-right-medium"
        aria-label="Pagination"
      >
        <div class="rs-navigation">
          <div
            class="rs-navigation-arrow rs-navigation-arrow-next"
            [class.rs-disabled]="
              currentPageNumber === pagesThatCanBeDisplayed.length
            "
          >
            <a
              class="rs-navigation-trigger"
              href="javascript:void(0)"
              (click)="onCurrentPageChange(null, 'goToNextPage')"
            >
              <i
                class="icon-Arrowbutton icon-lh icon-large"
                attr.aria-label="{{
                  'bills.cover.usageLevel4.tablePagination.nextPageLabel'
                    | translate
                }}"
              ></i>
            </a>
          </div>
          <div
            class="rs-navigation-arrow rs-navigation-arrow-prev"
            [class.rs-disabled]="currentPageNumber === 1"
          >
            <a
              class="rs-navigation-trigger"
              href="javascript:void(0)"
              tabindex="-1"
              (click)="onCurrentPageChange(null, 'goToPreviousPage')"
            >
              <i
                class="icon-Arrowbutton-left icon-lh icon-large"
                attr.aria-label="{{
                  'bills.cover.usageLevel4.tablePagination.previousPageLabel'
                    | translate
                }}"
              ></i>
            </a>
          </div>
        </div>
        <div class="rs-pagination-counter">
          <div class="rs-form-item">
            <label class="show-for-sr" for="ac-selectBox10">{{
              'bills.cover.usageLevel4.tablePagination.selectAPageLabel'
                | translate
            }}</label>
            <select
              #currentPageSelect
              id="ac-selectBox10"
              name="ac-selectBox10"
              (change)="onCurrentPageChange(currentPageSelect.value)"
              class="rs-filled"
              data-cy="myBillOdbUsagePageNumberDropdown"
            >
              <option
                *ngFor="let pageNumber of pagesThatCanBeDisplayed"
                [value]="pageNumber"
                [selected]="pageNumber === currentPageNumber"
              >
                {{ pageNumber }}
              </option>
            </select>
          </div>
          <span class="rs-pagination-counter-label"
            >{{ 'bills.cover.usageLevel4.tablePagination.of' | translate }}
            {{ totalNumberOfPages }}
            {{
              'bills.cover.usageLevel4.tablePagination.pages' | translate
            }}</span
          >
        </div>
      </div>
    </div>
    <div class="rs-flex-columns small-12 medium-6 rs-order-m1">
      <div
        class="rs-pagination rs-justify-between-small-only rs-justify-left-medium"
        aria-label="Pagination"
      >
        <div class="rs-pagination-counter">
          <div class="">
            <div class="rs-form-item">
              <label class="show-for-sr" for="ac-selectBox11">{{
                'bills.cover.usageLevel4.tablePagination.selectANumberOfItemsLabel'
                  | translate
              }}</label>
              <select
                #pageSizeSelect
                id="ac-selectBox11"
                name="ac-selectBox11"
                class="rs-filled"
                (change)="onPageSizeChange(pageSizeSelect.value)"
                data-cy="myBillOdbUsageItemsPerPageDropdown"
              >
                <option
                  *ngFor="let pageSizeOption of pageSizeOptions"
                  [value]="pageSizeOption"
                  [selected]="pageSizeOption === currentPageSize"
                >
                  {{ pageSizeOption }}
                </option>
              </select>
            </div>
          </div>
          <span class="rs-pagination-counter-label">{{
            'bills.cover.usageLevel4.tablePagination.itemsPerPage' | translate
          }}</span>
        </div>
        <div class="rs-pagination-text">
          <p>
            {{ rankOfFirstItemDisplayed }}-{{ rankOfLastItemDisplayed }}
            {{ 'bills.cover.usageLevel4.tablePagination.of' | translate }}
            {{ totalNumberOfItems }}
            {{ 'bills.cover.usageLevel4.tablePagination.items' | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</footer>
